/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_No_Request_Data_PeriodInputs */



/**
* | output |
* | --- |
* | "No data available for this period" |
*
* @param {Dashboard_No_Request_Data_PeriodInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const dashboard_no_request_data_period = /** @type {((inputs?: Dashboard_No_Request_Data_PeriodInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_No_Request_Data_PeriodInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Für diesen Zeitraum sind keine Anfragedaten verfügbar")
	return /** @type {LocalizedString} */ ("No data available for this period")
});